// Pre-prod deployment trigger: 2026-01-23 22:15 - Deploy after removing .skipNodeModules
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useSessionPersistence } from './hooks/useSessionPersistence';
import { SessionExpirationWarning } from './components/ui';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './components/LoginPage';
import ResetPassword from './components/ResetPassword';
import EmailVerification from './components/EmailVerification';
import ResendVerification from './components/ResendVerification';
import NotFound from './components/pages/NotFound';
import GeoBlocked from './components/pages/GeoBlocked';
import TawkToChat from './components/TawkToChat';
import UnifiedLayout from './components/layout/UnifiedLayout';
import { RoleProvider } from './contexts/RoleContext';
import { ScrollToTop } from './components/ScrollToTop';

import Frame123 from './components/frames/Frame123';
import Frame126 from './components/frames/Frame126';
import Frame129 from './components/frames/Frame129';
import MFAVerification from './components/frames/MFAVerification';
import Frame130 from './components/frames/Frame130';

import Frame132 from './components/frames/Frame132';
import Frame133 from './components/frames/Frame133';
import Frame134 from './components/frames/Frame134';
import Frame135 from './components/frames/Frame135';
import Frame137 from './components/frames/Frame137';
import Frame44 from './components/frames/Frame44';
import Frame47 from './components/frames/Frame47';
import Frame50 from './components/frames/Frame50';
import Frame53 from './components/frames/Frame53';
import Frame56 from './components/frames/Frame56';
import Frame138 from './components/frames/Frame138';
import Frame140 from './components/frames/Frame140';
import Frame141 from './components/frames/Frame141';
import Frame142 from './components/frames/Frame142';
import Frame143 from './components/frames/Frame143';
import Frame144 from './components/frames/Frame144';
import Frame145 from './components/frames/Frame145';
import Frame146 from './components/frames/Frame146';
import Frame147 from './components/frames/Frame147';
import Frame155 from './components/frames/Frame155';
import Frame157 from './components/frames/Frame157';
import Frame158 from './components/frames/Frame158';
import Frame159 from './components/frames/Frame159';
import Frame160 from './components/frames/Frame160';
import Frame161 from './components/frames/Frame161';
import Frame163 from './components/frames/Frame163';
import Frame165 from './components/frames/Frame165';

import Frame172 from './components/frames/Frame172';
import Frame173 from './components/frames/Frame173';
import Frame174 from './components/frames/Frame174';

import Frame182 from './components/frames/Frame182';
import Frame186 from './components/frames/Frame186';
import Frame187 from './components/frames/Frame187';
import Frame188 from './components/frames/Frame188';
import Frame189 from './components/frames/Frame189';
import Frame190 from './components/frames/Frame190';
import Frame191 from './components/frames/Frame191';

import Frame196 from './components/frames/Frame196';
import Frame199 from './components/frames/Frame199';
import Frame202 from './components/frames/Frame202';
import Frame203 from './components/frames/Frame203';
import Frame211 from './components/frames/Frame211';
import Frame212 from './components/frames/Frame212';
import Frame213 from './components/frames/Frame213';
import Frame214 from './components/frames/Frame214';
import Frame215 from './components/frames/Frame215';

import Frame219 from './components/frames/Frame219';
import Frame221 from './components/frames/Frame221';
import Frame222 from './components/frames/Frame222';
import Frame223 from './components/frames/Frame223';
import Frame224 from './components/frames/Frame224';

import Frame234 from './components/frames/Frame234';
import Frame235 from './components/frames/Frame235';
import Frame236 from './components/frames/Frame236';
import Frame237 from './components/frames/Frame237';
import Frame238 from './components/frames/Frame238';
import Frame239 from './components/frames/Frame239';
import Frame240 from './components/frames/Frame240';
import Frame241 from './components/frames/Frame241';
import Frame242 from './components/frames/Frame242';
import Frame243 from './components/frames/Frame243';
import Frame244 from './components/frames/Frame244';
import Frame244PetsFinal from './components/frames/Frame244PetsFinal';
import Frame20 from './components/frames/Frame20';
import Frame20_1 from './components/frames/Frame20_1';
import Frame21 from './components/frames/Frame21';
import Frame22 from './components/frames/Frame22';
import Frame23 from './components/frames/Frame23';
import Frame24 from './components/frames/Frame24';
import Frame245 from './components/frames/Frame245';
import Frame246 from './components/frames/Frame246';
import Frame247 from './components/frames/Frame247';
import Frame248 from './components/frames/Frame248';
import Frame249 from './components/frames/Frame249';

import Frame250 from './components/frames/Frame250';
import Frame251 from './components/frames/Frame251';

import Frame260 from './components/frames/Frame260';
import Frame261 from './components/frames/Frame261';
import Frame26 from './components/frames/Frame26';
import Frame27 from './components/frames/Frame27';
import Frame29 from './components/frames/Frame29';
import Frame32 from './components/frames/Frame32';
import Frame35 from './components/frames/Frame35';
import Frame38 from './components/frames/Frame38';

import Frame301 from './components/frames/Frame301';
import Frame302 from './components/frames/Frame302';
import Frame383 from './components/frames/Frame383';
import Frame3_1 from './components/frames/Frame3_1';
import Frame3_11 from './components/frames/Frame3_11';
import Frame3_2 from './components/frames/Frame3_2';
import Frame3_2_1 from './components/frames/Frame3_2_1';
import Frame3_3 from './components/frames/Frame3_3';
import Frame3_3_1 from './components/frames/Frame3_3_1';
import Frame303 from './components/frames/Frame303';
import Frame304 from './components/frames/Frame304';

import Frame800 from './components/frames/Frame800';
import Frame801 from './components/frames/Frame801';
import Frame802 from './components/frames/Frame802';
import Frame803 from './components/frames/Frame803';

import SettingsPage from './components/frames/SettingsPage';
import SupportPage from './components/frames/SupportPage';
import DeleteAccountAnimation from './components/frames/DeleteAccountAnimation';
import SignupCapture from './components/frames/SignupCapture';
import ExecutorDashboard from './components/frames/ExecutorDashboard';
import SettlementFlow from './components/frames/SettlementFlow';
import EstateSelector from './components/frames/EstateSelector';
import ExecutorComingSoon from './components/frames/ExecutorComingSoon';
import BeneficiaryComingSoon from './components/frames/BeneficiaryComingSoon';
import VerifyEmailPending from './components/frames/VerifyEmailPending';

// Settlement components
import SettlementLayout from './components/layout/SettlementLayout';
import SFrame100 from './components/sframes/SFrame100';
import SFrame101 from './components/sframes/SFrame101';
import SFrame105 from './components/sframes/SFrame105';
import SFrame107 from './components/sframes/SFrame107';
import SFrame109 from './components/sframes/SFrame109';
import SFrame110 from './components/sframes/SFrame110';
import SFrame111 from './components/sframes/SFrame111';
import SFrame117 from './components/sframes/SFrame117';
import SFrame124 from './components/sframes/SFrame124';
import SFrame126 from './components/sframes/SFrame126';
import SFrame129S from './components/sframes/SFrame129';
import SFrame131 from './components/sframes/SFrame131';
import SFrame134S from './components/sframes/SFrame134';
import SFrame137S from './components/sframes/SFrame137';
import SFrame138S from './components/sframes/SFrame138';
import SFrame141 from './components/sframes/SFrame141';
import SFrame143 from './components/sframes/SFrame143';
import SFrame170 from './components/sframes/SFrame170';
import SFrame180 from './components/sframes/SFrame180';
import SFrame181 from './components/sframes/SFrame181';
import SFrame183 from './components/sframes/SFrame183';
import SFrame186S from './components/sframes/SFrame186';
import SFrame198 from './components/sframes/SFrame198';
import SFrame199 from './components/sframes/SFrame199';
import ReviewOrganize_CollectDebts from './components/sframes/debts/ReviewOrganize_CollectDebts';
import ReviewOrganize_IdentifyTypes from './components/sframes/debts/ReviewOrganize_IdentifyTypes';
import ReviewOrganize_FlagDisputed from './components/sframes/debts/ReviewOrganize_FlagDisputed';
import ReviewOrganize_CompileInventory from './components/sframes/debts/ReviewOrganize_CompileInventory';
import SFrame202 from './components/sframes/SFrame202';
import PlanPayment_LegalPriority from './components/sframes/debts/PlanPayment_LegalPriority';
import PlanPayment_DebtPriority from './components/sframes/debts/PlanPayment_DebtPriority';
import PlanPayment_Liquidity from './components/sframes/debts/PlanPayment_Liquidity';
import PlanPayment_Schedule from './components/sframes/debts/PlanPayment_Schedule';
import PlanPayment_Finalize from './components/sframes/debts/PlanPayment_Finalize';
import SFrame204 from './components/sframes/SFrame204';
import SFrame206 from './components/sframes/SFrame206';
import SFrame208 from './components/sframes/SFrame208';
import SFrame209 from './components/sframes/SFrame209';
import SFrame210 from './components/sframes/SFrame210';
import SFrame212 from './components/sframes/SFrame212';
import SFrame214 from './components/sframes/SFrame214';
import SFrame207 from './components/sframes/SFrame207';
import SFrame215 from './components/sframes/SFrame215';
import PayDebts_FinalPrep from './components/sframes/debts/PayDebts_FinalPrep';
import PayDebts_HighPriority from './components/sframes/debts/PayDebts_HighPriority';
import PayDebts_TaxGov from './components/sframes/debts/PayDebts_TaxGov';
import PayDebts_Documentation from './components/sframes/debts/PayDebts_Documentation';
import SFrame220 from './components/sframes/SFrame220';
import SFrame250S from './components/sframes/SFrame250';
import SFrame251 from './components/sframes/SFrame251';
import SFrame252 from './components/sframes/SFrame252';
import SFrame253 from './components/sframes/SFrame253';
import SFrame254 from './components/sframes/SFrame254';
import SFrame255 from './components/sframes/SFrame255';
import SFrame256 from './components/sframes/SFrame256';
import SFrame257 from './components/sframes/SFrame257';
import SFrame258 from './components/sframes/SFrame258';
import SFrame259 from './components/sframes/SFrame259';
import SFrame160Business from './components/sframes/secureInventory/SFrame160Business';
import {
  SFrame146, SFrame150, SFrame155 as SFrame155S, SFrame160 as SFrame160S,
  SFrame162, SFrame163,
  SFrame171,
  SFrame172S as SFrame172SS,
  SFrame173,
  SFrame174S as SFrame174SS,
  SFrame175,
  SFrame176,
  SFrame200, SFrame201,
  SFrame221S, SFrame222S, SFrame224S, SFrame230, SFrame235S, SFrame240S, SFrame245S,
} from './components/sframes/settlementStepScreens';

import FlowResumeFrameWrapper from './components/FlowResumeFrameWrapper';

// Admin components
import { AdminDashboard, AdminAnalytics, AdminUsers, AdminKBManager, AdminGeoBlocking, AdminLeads, AdminDeathCerts } from './components/admin';

//Executor-only components
import ExecutorOnlyRoute from './components/ExecutorPlanningRoute';
import ExecutorPlanningLayout from './components/layout/ExecutorPlanningLayout';

import EFrame141 from './components/eframes/EFrame141';
import EFrame142 from './components/eframes/EFrame142';
import EFrame146 from './components/eframes/EFrame146';
import EFrame143 from './components/eframes/EFrame143';
import EFrame144 from './components/eframes/EFrame144';
import EFrame145 from './components/eframes/EFrame145';
import EFrame135 from './components/eframes/EFrame135';
import EFrame173 from './components/eframes/EFrame173';
import EFrame223 from './components/eframes/EFrame223';
import EFrame802 from './components/eframes/EFrame802';
import EFrame248 from './components/eframes/EFrame248';
import EFrame213 from './components/eframes/EFrame213';
import EFrame238 from './components/eframes/EFrame238';
import EFrame247 from './components/eframes/EFrame247';
import EFrame215 from './components/eframes/EFrame215';

const withAuth = (node: React.ReactNode) => <ProtectedRoute>{node}</ProtectedRoute>;

function RedirectToSFrame146() {
  const { estateId } = useParams<{ estateId: string }>();
  return <Navigate replace to={estateId ? `/sframe-146/${estateId}` : '/sframe-146'} />;
}
const withFlow = (node: React.ReactNode) => (
  <ProtectedRoute>
    <FlowResumeFrameWrapper>{node}</FlowResumeFrameWrapper>
  </ProtectedRoute>
);

const App: React.FC = () => {
  const { session, sessionExpired, showExpirationWarning, warningTimeRemainingMs, extendSession, logoutSession } = useSessionPersistence();

  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem('account-token'));

  useEffect(() => {
    const checkAuth = () => setIsAuthenticated(!!localStorage.getItem('account-token'));
    checkAuth();
    window.addEventListener('storage', checkAuth);
    const interval = setInterval(checkAuth, 1000);
    return () => {
      window.removeEventListener('storage', checkAuth);
      clearInterval(interval);
    };
  }, [session.accountId]);

  return (
    <Router>
      <ScrollToTop />
      <RoleProvider>
        <TawkToChat isAuthenticated={isAuthenticated} />
        <SessionExpirationWarning
          sessionExpired={sessionExpired}
          showWarning={showExpirationWarning}
          warningTimeRemainingMs={warningTimeRemainingMs}
          onExtendSession={extendSession}
          onLogout={logoutSession}
        />

        <Routes>
        <Route path="/" element={<Frame211 />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/mfa-verify" element={<MFAVerification />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<EmailVerification />} />
        <Route path="/verify-email-pending" element={<VerifyEmailPending />} />
        <Route path="/resend-verification" element={<ResendVerification />} />
        <Route path="/signup-newsletter" element={<SignupCapture />} />
        <Route path="/signup-FFbeta" element={<SignupCapture />} />

        {/* Pages excluded from UnifiedLayout - no header/nav */}
        <Route path="/frame-129" element={<Frame129 />} />
        <Route path="/frame-134" element={<Frame134 />} />
        <Route path="/frame-199" element={<ProtectedRoute><Frame199 /></ProtectedRoute>} />
        <Route path="/frame-250" element={<ProtectedRoute><Frame250 /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path="/support" element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
        <Route path="/deleteaccount" element={<DeleteAccountAnimation />} />

        <Route element={<UnifiedLayout />}>
          <Route path="/frame-140" element={<ProtectedRoute><Frame140 /></ProtectedRoute>} />
          <Route path="/frame-123" element={<Frame123 />} />
          <Route path="/frame-126" element={<Frame126 />} />
          <Route path="/frame-130" element={<Frame130 />} />

          {/* ABOUT (flow-wrapped) */}
          <Route path="/frame-132" element={withFlow(<Frame132 />)} />
          <Route path="/frame-133" element={withFlow(<Frame133 />)} />
          <Route path="/frame-135" element={withFlow(<Frame135 />)} />
          <Route path="/frame-137" element={withFlow(<Frame137 />)} />
          <Route path="/frame-138" element={withFlow(<Frame138 />)} />

          {/* AUTH-ONLY NON-FLOW FRAMES */}
          <Route path="/frame-141" element={<ProtectedRoute><Frame141 /></ProtectedRoute>} />
          <Route path="/frame-142" element={<ProtectedRoute><Frame142 /></ProtectedRoute>} />
          <Route path="/frame-143" element={<ProtectedRoute><Frame143 /></ProtectedRoute>} />
          <Route path="/frame-144" element={<ProtectedRoute><Frame144 /></ProtectedRoute>} />
          <Route path="/frame-145" element={<ProtectedRoute><Frame145 /></ProtectedRoute>} />
          <Route path="/frame-146" element={<ProtectedRoute><Frame146 /></ProtectedRoute>} />
          <Route path="/frame-147" element={<ProtectedRoute><Frame147 /></ProtectedRoute>} />
          <Route path="/frame-155" element={<ProtectedRoute><Frame155 /></ProtectedRoute>} />
          <Route path="/frame-158" element={<ProtectedRoute><Frame158 /></ProtectedRoute>} />
          <Route path="/frame-159" element={<ProtectedRoute><Frame159 /></ProtectedRoute>} />
          <Route path="/frame-160" element={<ProtectedRoute><Frame160 /></ProtectedRoute>} />
          <Route path="/frame-161" element={<ProtectedRoute><Frame161 /></ProtectedRoute>} />
          <Route path="/frame-163" element={<ProtectedRoute><Frame163 /></ProtectedRoute>} />
          <Route path="/frame-165" element={<ProtectedRoute><Frame165 /></ProtectedRoute>} />
          <Route path="/frame-196" element={<ProtectedRoute><Frame196 /></ProtectedRoute>} />
          <Route path="/frame-202" element={<ProtectedRoute><Frame202 /></ProtectedRoute>} />
          <Route path="/frame-203" element={<ProtectedRoute><Frame203 /></ProtectedRoute>} />
          <Route path="/frame-212" element={<ProtectedRoute><Frame212 /></ProtectedRoute>} />
          <Route path="/frame-224" element={<ProtectedRoute><Frame224 /></ProtectedRoute>} />
          <Route path="/frame-251" element={<ProtectedRoute><Frame251 /></ProtectedRoute>} />
          <Route path="/frame-803" element={<ProtectedRoute><Frame803 /></ProtectedRoute>} />

          {/* LEGACY (flow-wrapped) */}
          <Route path="/frame-157" element={withFlow(<Frame157 />)} />
          <Route path="/frame-172" element={withFlow(<Frame172 />)} />
          <Route path="/frame-173" element={withFlow(<Frame173 />)} />

          {/* LEGAL ESSENTIALS (flow-wrapped) */}
          <Route path="/frame-214" element={withFlow(<Frame214 />)} />
          <Route path="/frame-215" element={withFlow(<Frame215 />)} />
          <Route path="/frame-260" element={withFlow(<Frame260 />)} />
          <Route path="/frame-261" element={withFlow(<Frame261 />)} />

          {/* INVENTORY (flow-wrapped) */}
          <Route path="/frame-174" element={withFlow(<Frame174 />)} />
          <Route path="/frame-182" element={withAuth(<Frame182 />)} />
          <Route path="/frame-186" element={withFlow(<Frame186 />)} />
          <Route path="/frame-187" element={withFlow(<Frame187 />)} />
          <Route path="/frame-188" element={withFlow(<Frame188 />)} />
          <Route path="/frame-189" element={withFlow(<Frame189 />)} />
          <Route path="/frame-191" element={withFlow(<Frame191 />)} />
          <Route path="/frame-190" element={withFlow(<Frame190 />)} />
          <Route path="/frame-213" element={withFlow(<Frame213 />)} />
          <Route path="/frame-219" element={withFlow(<Frame219 />)} />
          <Route path="/frame-221" element={withFlow(<Frame221 />)} />
          <Route path="/frame-222" element={withFlow(<Frame222 />)} />
          <Route path="/frame-223" element={withFlow(<Frame223 />)} />

          {/* DEBTS (flow-wrapped) */}
          <Route path="/frame-234" element={withFlow(<Frame234 />)} />
          <Route path="/frame-235" element={withFlow(<Frame235 />)} />
          <Route path="/frame-236" element={withFlow(<Frame236 />)} />
          <Route path="/frame-237" element={withFlow(<Frame237 />)} />
          <Route path="/frame-238" element={withFlow(<Frame238 />)} />
          <Route path="/frame-239" element={withFlow(<Frame239 />)} />
          <Route path="/frame-240" element={withFlow(<Frame240 />)} />

          {/* PETS (flow-wrapped) */}
          <Route path="/frame-241" element={withFlow(<Frame241 />)} />
          <Route path="/frame-242" element={withFlow(<Frame242 />)} />
          <Route path="/frame-243" element={withFlow(<Frame243 />)} />
          <Route path="/frame-244-pets" element={withFlow(<Frame244PetsFinal />)} />
          <Route path="/frame-248" element={withFlow(<Frame248 />)} />
          <Route path="/frame-249" element={withFlow(<Frame249 />)} />

          {/* PERSONAL BELONGINGS (flow-wrapped) */}
          <Route path="/frame-800" element={withFlow(<Frame800 />)} />
          <Route path="/frame-801" element={withFlow(<Frame801 />)} />
          <Route path="/frame-802" element={withFlow(<Frame802 />)} />

          {/* DISTRIBUTION (flow-wrapped) */}
          <Route path="/frame-245" element={withFlow(<Frame245 />)} />
          <Route path="/frame-246" element={withFlow(<Frame246 />)} />
          <Route path="/frame-247" element={withFlow(<Frame247 />)} />

          {/* PLAN ACCESS CONFIRMATION (flow-wrapped if intentional in your app architecture) */}
          <Route path="/frame-301" element={withFlow(<Frame301 />)} />
          <Route path="/frame-302" element={withFlow(<Frame302 />)} />
          <Route path="/frame-303" element={withFlow(<Frame303 />)} />
          <Route path="/frame-304" element={withFlow(<Frame304 />)} />
        </Route>
        
        {/* Settlement welcome screen */}
        <Route path="/frame-383" element={<Frame383 />} />
        <Route path="/frame-383/:estateId" element={<Frame383 />} />

        {/* IAD — Death certificate workflow (Frames 20, 20.1, 244, 21–24) */}
        <Route path="/frame-20" element={withAuth(<Frame20 />)} />
        <Route path="/frame-20/:estateId" element={withAuth(<Frame20 />)} />
        <Route path="/frame-20-1" element={withAuth(<Frame20_1 />)} />
        <Route path="/frame-20-1/:estateId" element={withAuth(<Frame20_1 />)} />
        <Route path="/frame-244" element={withAuth(<Frame244 />)} />
        <Route path="/frame-244/:estateId" element={withAuth(<Frame244 />)} />
        <Route path="/frame-21" element={withAuth(<Frame21 />)} />
        <Route path="/frame-21/:estateId" element={withAuth(<Frame21 />)} />
        <Route path="/frame-22" element={withAuth(<Frame22 />)} />
        <Route path="/frame-22/:estateId" element={withAuth(<Frame22 />)} />
        <Route path="/frame-23" element={withAuth(<Frame23 />)} />
        <Route path="/frame-23/:estateId" element={withAuth(<Frame23 />)} />
        <Route path="/frame-24" element={withAuth(<Frame24 />)} />
        <Route path="/frame-24/:estateId" element={withAuth(<Frame24 />)} />

        {/* Settlement plan summary pages */}
        <Route path="/frame-3-1" element={<Frame3_1 />} />
        <Route path="/frame-3-1/:estateId" element={<Frame3_1 />} />
        <Route path="/frame-3-11" element={<Frame3_11 />} />
        <Route path="/frame-3-11/:estateId" element={<Frame3_11 />} />
        <Route path="/frame-3-2" element={<Frame3_2 />} />
        <Route path="/frame-3-2/:estateId" element={<Frame3_2 />} />
        <Route path="/frame-3-2-1" element={<Frame3_2_1 />} />
        <Route path="/frame-3-2-1/:estateId" element={<Frame3_2_1 />} />
        <Route path="/frame-3-3" element={<Frame3_3 />} />
        <Route path="/frame-3-3/:estateId" element={<Frame3_3 />} />
        <Route path="/frame-3-3-1" element={<Frame3_3_1 />} />
        <Route path="/frame-3-3-1/:estateId" element={<Frame3_3_1 />} />

        {/* Settlement onboarding (public or semi-public, no sidebar layout) */}
        <Route path="/sframe-100" element={<SFrame100 />} />
        <Route path="/sframe-101" element={<SFrame101 />} />
        <Route path="/sframe-105" element={<SFrame105 />} />
        <Route path="/sframe-107" element={withAuth(<SFrame107 />)} />
        <Route path="/sframe-109" element={withAuth(<SFrame109 />)} />
        <Route path="/sframe-110" element={withAuth(<SFrame110 />)} />
        <Route path="/sframe-111" element={withAuth(<SFrame111 />)} />

        {/* Settlement dashboard routes (auth + settlement layout) */}
        <Route element={<SettlementLayout />}>
          <Route path="/sframe-117" element={withAuth(<SFrame117 />)} />
          <Route path="/sframe-117/:estateId" element={withAuth(<SFrame117 />)} />

          {/* Phase 1: Immediately After Death */}
          <Route path="/sframe-141" element={withAuth(<SFrame141 />)} />
          <Route path="/sframe-141/:estateId" element={withAuth(<SFrame141 />)} />
          <Route path="/sframe-124" element={withAuth(<SFrame124 />)} />
          <Route path="/sframe-124/:estateId" element={withAuth(<SFrame124 />)} />
          <Route path="/sframe-126" element={withAuth(<SFrame126 />)} />
          <Route path="/sframe-126/:estateId" element={withAuth(<SFrame126 />)} />
          <Route path="/sframe-129" element={withAuth(<SFrame129S />)} />
          <Route path="/sframe-129/:estateId" element={withAuth(<SFrame129S />)} />
          <Route path="/sframe-131" element={withAuth(<SFrame131 />)} />
          <Route path="/sframe-131/:estateId" element={withAuth(<SFrame131 />)} />
          <Route path="/sframe-134" element={withAuth(<SFrame134S />)} />
          <Route path="/sframe-134/:estateId" element={withAuth(<SFrame134S />)} />
          <Route path="/frame-26" element={withAuth(<Frame26 />)} />
          <Route path="/frame-26/:estateId" element={withAuth(<Frame26 />)} />
          <Route path="/frame-27" element={withAuth(<Frame27 />)} />
          <Route path="/frame-27/:estateId" element={withAuth(<Frame27 />)} />
          <Route path="/frame-29" element={withAuth(<Frame29 />)} />
          <Route path="/frame-29/:estateId" element={withAuth(<Frame29 />)} />
          <Route path="/frame-32" element={withAuth(<Frame32 />)} />
          <Route path="/frame-32/:estateId" element={withAuth(<Frame32 />)} />
          <Route path="/frame-35" element={withAuth(<Frame35 />)} />
          <Route path="/frame-35/:estateId" element={withAuth(<Frame35 />)} />
          <Route path="/frame-38" element={withAuth(<Frame38 />)} />
          <Route path="/frame-38/:estateId" element={withAuth(<Frame38 />)} />
          <Route path="/sframe-137" element={withAuth(<SFrame137S />)} />
          <Route path="/sframe-137/:estateId" element={withAuth(<SFrame137S />)} />
          <Route path="/frame-44" element={withAuth(<Frame44 />)} />
          <Route path="/frame-44/:estateId" element={withAuth(<Frame44 />)} />
          <Route path="/frame-47" element={withAuth(<Frame47 />)} />
          <Route path="/frame-47/:estateId" element={withAuth(<Frame47 />)} />
          <Route path="/frame-50" element={withAuth(<Frame50 />)} />
          <Route path="/frame-50/:estateId" element={withAuth(<Frame50 />)} />
          <Route path="/frame-53" element={withAuth(<Frame53 />)} />
          <Route path="/frame-53/:estateId" element={withAuth(<Frame53 />)} />
          <Route path="/frame-56" element={withAuth(<Frame56 />)} />
          <Route path="/frame-56/:estateId" element={withAuth(<Frame56 />)} />
          <Route path="/sframe-138" element={withAuth(<SFrame138S />)} />
          <Route path="/sframe-138/:estateId" element={withAuth(<SFrame138S />)} />

          {/* Phase 2: Secure & Inventory Assets */}
          <Route path="/sframe-143" element={withAuth(<SFrame143 />)} />
          <Route path="/sframe-143/:estateId" element={withAuth(<SFrame143 />)} />
          <Route path="/sframe-144" element={<Navigate replace to="/sframe-146" />} />
          <Route path="/sframe-144/:estateId" element={<RedirectToSFrame146 />} />
          <Route path="/sframe-146" element={withAuth(<SFrame146 />)} />
          <Route path="/sframe-146/:estateId" element={withAuth(<SFrame146 />)} />
          <Route path="/sframe-150" element={withAuth(<SFrame150 />)} />
          <Route path="/sframe-150/:estateId" element={withAuth(<SFrame150 />)} />
          <Route path="/sframe-155" element={withAuth(<SFrame155S />)} />
          <Route path="/sframe-155/:estateId" element={withAuth(<SFrame155S />)} />
          <Route path="/sframe-160" element={withAuth(<SFrame160S />)} />
          <Route path="/sframe-160/:estateId" element={withAuth(<SFrame160S />)} />
          <Route path="/sframe-161" element={withAuth(<SFrame160Business />)} />
          <Route path="/sframe-161/:estateId" element={withAuth(<SFrame160Business />)} />
          <Route path="/sframe-162" element={withAuth(<SFrame162 />)} />
          <Route path="/sframe-162/:estateId" element={withAuth(<SFrame162 />)} />
          <Route path="/sframe-163" element={withAuth(<SFrame163 />)} />
          <Route path="/sframe-163/:estateId" element={withAuth(<SFrame163 />)} />

          {/* Phase 3: Probate & Legal */}
          <Route path="/sframe-170" element={withAuth(<SFrame170 />)} />
          <Route path="/sframe-170/:estateId" element={withAuth(<SFrame170 />)} />
          <Route path="/sframe-171" element={withAuth(<SFrame171 />)} />
          <Route path="/sframe-171/:estateId" element={withAuth(<SFrame171 />)} />
          <Route path="/sframe-172" element={withAuth(<SFrame172SS />)} />
          <Route path="/sframe-172/:estateId" element={withAuth(<SFrame172SS />)} />
          <Route path="/sframe-173" element={withAuth(<SFrame173 />)} />
          <Route path="/sframe-173/:estateId" element={withAuth(<SFrame173 />)} />
          <Route path="/sframe-174" element={withAuth(<SFrame174SS />)} />
          <Route path="/sframe-174/:estateId" element={withAuth(<SFrame174SS />)} />
          <Route path="/sframe-175" element={withAuth(<SFrame175 />)} />
          <Route path="/sframe-175/:estateId" element={withAuth(<SFrame175 />)} />
          <Route path="/sframe-176" element={withAuth(<SFrame176 />)} />
          <Route path="/sframe-176/:estateId" element={withAuth(<SFrame176 />)} />

          {/* Phase 4: Notify Interested Parties */}
          <Route path="/sframe-180" element={withAuth(<SFrame180 />)} />
          <Route path="/sframe-180/:estateId" element={withAuth(<SFrame180 />)} />
          <Route path="/sframe-181" element={withAuth(<SFrame181 />)} />
          <Route path="/sframe-181/:estateId" element={withAuth(<SFrame181 />)} />
          <Route path="/sframe-183" element={withAuth(<SFrame183 />)} />
          <Route path="/sframe-183/:estateId" element={withAuth(<SFrame183 />)} />
          <Route path="/sframe-186" element={withAuth(<SFrame186S />)} />
          <Route path="/sframe-186/:estateId" element={withAuth(<SFrame186S />)} />

          {/* Phase 5: Debts, Expenses & Taxes */}
          <Route path="/sframe-198" element={withAuth(<SFrame198 />)} />
          <Route path="/sframe-198/:estateId" element={withAuth(<SFrame198 />)} />
          <Route path="/sframe-199" element={withAuth(<SFrame199 />)} />
          <Route path="/sframe-199/:estateId" element={withAuth(<SFrame199 />)} />
          <Route path="/sframe-199-s1/:estateId" element={withAuth(<ReviewOrganize_CollectDebts />)} />
          <Route path="/sframe-199-s2/:estateId" element={withAuth(<ReviewOrganize_IdentifyTypes />)} />
          <Route path="/sframe-199-s4/:estateId" element={withAuth(<ReviewOrganize_FlagDisputed />)} />
          <Route path="/sframe-199-s5/:estateId" element={withAuth(<ReviewOrganize_CompileInventory />)} />
          <Route path="/sframe-200" element={withAuth(<SFrame200 />)} />
          <Route path="/sframe-200/:estateId" element={withAuth(<SFrame200 />)} />
          <Route path="/sframe-201" element={withAuth(<SFrame201 />)} />
          <Route path="/sframe-201/:estateId" element={withAuth(<SFrame201 />)} />
          <Route path="/sframe-202" element={withAuth(<SFrame202 />)} />
          <Route path="/sframe-202/:estateId" element={withAuth(<SFrame202 />)} />
          <Route path="/sframe-202-s1/:estateId" element={withAuth(<PlanPayment_LegalPriority />)} />
          <Route path="/sframe-202-s2/:estateId" element={withAuth(<PlanPayment_DebtPriority />)} />
          <Route path="/sframe-202-s3/:estateId" element={withAuth(<PlanPayment_Liquidity />)} />
          <Route path="/sframe-202-s4/:estateId" element={withAuth(<PlanPayment_Schedule />)} />
          <Route path="/sframe-202-s5/:estateId" element={withAuth(<PlanPayment_Finalize />)} />
          <Route path="/sframe-204" element={withAuth(<SFrame204 />)} />
          <Route path="/sframe-204/:estateId" element={withAuth(<SFrame204 />)} />
          <Route path="/sframe-204-s1/:estateId" element={withAuth(<PayDebts_FinalPrep />)} />
          <Route path="/sframe-204-s2/:estateId" element={withAuth(<PayDebts_HighPriority />)} />
          <Route path="/sframe-204-s3/:estateId" element={withAuth(<PayDebts_TaxGov />)} />
          <Route path="/sframe-204-s5/:estateId" element={withAuth(<PayDebts_Documentation />)} />
          <Route path="/sframe-206" element={withAuth(<SFrame206 />)} />
          <Route path="/sframe-206/:estateId" element={withAuth(<SFrame206 />)} />
          <Route path="/sframe-207" element={withAuth(<SFrame207 />)} />
          <Route path="/sframe-207/:estateId" element={withAuth(<SFrame207 />)} />
          <Route path="/sframe-208" element={withAuth(<SFrame208 />)} />
          <Route path="/sframe-208/:estateId" element={withAuth(<SFrame208 />)} />
          <Route path="/sframe-209" element={withAuth(<SFrame209 />)} />
          <Route path="/sframe-209/:estateId" element={withAuth(<SFrame209 />)} />
          <Route path="/sframe-210" element={withAuth(<SFrame210 />)} />
          <Route path="/sframe-210/:estateId" element={withAuth(<SFrame210 />)} />
          <Route path="/sframe-212" element={withAuth(<SFrame212 />)} />
          <Route path="/sframe-212/:estateId" element={withAuth(<SFrame212 />)} />
          <Route path="/sframe-214" element={withAuth(<SFrame214 />)} />
          <Route path="/sframe-214/:estateId" element={withAuth(<SFrame214 />)} />
          <Route path="/sframe-215" element={withAuth(<SFrame215 />)} />
          <Route path="/sframe-215/:estateId" element={withAuth(<SFrame215 />)} />

          {/* Phase 6: Distribute Assets */}
          <Route path="/sframe-220" element={withAuth(<SFrame220 />)} />
          <Route path="/sframe-220/:estateId" element={withAuth(<SFrame220 />)} />
          <Route path="/sframe-221" element={withAuth(<SFrame221S />)} />
          <Route path="/sframe-221/:estateId" element={withAuth(<SFrame221S />)} />
          <Route path="/sframe-222" element={withAuth(<SFrame222S />)} />
          <Route path="/sframe-222/:estateId" element={withAuth(<SFrame222S />)} />
          <Route path="/sframe-224" element={withAuth(<SFrame224S />)} />
          <Route path="/sframe-224/:estateId" element={withAuth(<SFrame224S />)} />
          <Route path="/sframe-230" element={withAuth(<SFrame230 />)} />
          <Route path="/sframe-230/:estateId" element={withAuth(<SFrame230 />)} />
          <Route path="/sframe-235" element={withAuth(<SFrame235S />)} />
          <Route path="/sframe-235/:estateId" element={withAuth(<SFrame235S />)} />
          <Route path="/sframe-240" element={withAuth(<SFrame240S />)} />
          <Route path="/sframe-240/:estateId" element={withAuth(<SFrame240S />)} />
          <Route path="/sframe-245" element={withAuth(<SFrame245S />)} />
          <Route path="/sframe-245/:estateId" element={withAuth(<SFrame245S />)} />

          {/* Phase 7: Close the Estate */}
          <Route path="/sframe-250" element={withAuth(<SFrame250S />)} />
          <Route path="/sframe-250/:estateId" element={withAuth(<SFrame250S />)} />
          <Route path="/sframe-251" element={withAuth(<SFrame251 />)} />
          <Route path="/sframe-251/:estateId" element={withAuth(<SFrame251 />)} />
          <Route path="/sframe-252" element={withAuth(<SFrame252 />)} />
          <Route path="/sframe-252/:estateId" element={withAuth(<SFrame252 />)} />
          <Route path="/sframe-253" element={withAuth(<SFrame253 />)} />
          <Route path="/sframe-253/:estateId" element={withAuth(<SFrame253 />)} />
          <Route path="/sframe-254" element={withAuth(<SFrame254 />)} />
          <Route path="/sframe-254/:estateId" element={withAuth(<SFrame254 />)} />
          <Route path="/sframe-255" element={withAuth(<SFrame255 />)} />
          <Route path="/sframe-255/:estateId" element={withAuth(<SFrame255 />)} />
          <Route path="/sframe-256" element={withAuth(<SFrame256 />)} />
          <Route path="/sframe-256/:estateId" element={withAuth(<SFrame256 />)} />
          <Route path="/sframe-257" element={withAuth(<SFrame257 />)} />
          <Route path="/sframe-257/:estateId" element={withAuth(<SFrame257 />)} />
          <Route path="/sframe-258" element={withAuth(<SFrame258 />)} />
          <Route path="/sframe-258/:estateId" element={withAuth(<SFrame258 />)} />
          <Route path="/sframe-259" element={withAuth(<SFrame259 />)} />
          <Route path="/sframe-259/:estateId" element={withAuth(<SFrame259 />)} />
        </Route>

        {/* Executor Routes */}
        <Route path="/estate-selector" element={withAuth(<EstateSelector />)} />
        <Route path="/executor-coming-soon/:estateId" element={withAuth(<ExecutorComingSoon />)} />
        <Route path="/beneficiary-coming-soon/:estateId" element={withAuth(<BeneficiaryComingSoon />)} />
        <Route path="/executor/:estateId" element={withAuth(<ExecutorDashboard />)} />
        <Route path="/settlement/:estateId" element={withAuth(<SettlementFlow />)} />
        {/* NEW: Executor Planning (Read-Only) */}
        <Route
          path="/executor-plan/:estateId"
          element={
            <ProtectedRoute>
              <ExecutorOnlyRoute>
                <ExecutorPlanningLayout />
              </ExecutorOnlyRoute>
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="eframe-141" replace />} />
          <Route path="eframe-142" element={<EFrame142 />} />
          <Route path="eframe-146" element={<EFrame146 />} />
          <Route path="eframe-143" element={<EFrame143 />} />
          <Route path="eframe-144" element={<EFrame144 />} />
          <Route path="eframe-145" element={<EFrame145 />} />
          <Route path="eframe-141" element={<EFrame141 />} />
          <Route path="eframe-135" element={<EFrame135 />} />
          <Route path="eframe-173" element={<EFrame173 />} />
          <Route path="eframe-223" element={<EFrame223 />} />
          <Route path="eframe-802" element={<EFrame802 />} />
          <Route path="eframe-248" element={<EFrame248 />} />
          <Route path="eframe-213" element={<EFrame213 />} />
          <Route path="eframe-238" element={<EFrame238 />} />
          <Route path="eframe-247" element={<EFrame247 />} />
          <Route path="eframe-215" element={<EFrame215 />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/analytics" element={<AdminAnalytics />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/kb" element={<AdminKBManager />} />
        <Route path="/admin/geo-blocking" element={<AdminGeoBlocking />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
        <Route path="/admin/death-certs" element={<AdminDeathCerts />} />

        <Route path="/geo-blocked" element={<GeoBlocked />} />
        <Route path="*" element={<NotFound />} />
        </Routes>
      </RoleProvider>
    </Router>
  );
};

export default App;